import { apiPost } from "./apiClient";
import { fetchCanonicalAttachmentBlob } from "../../../messaging/canonicalMessagingApi";

export async function downloadChatAttachment(attachmentId) {
  if (!attachmentId) throw new Error("Chat attachment is unavailable.");
  return { blob: await fetchCanonicalAttachmentBlob(attachmentId) };
}

export function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}

// Uploads a File/Blob to the permanent image store. Callers build the
// File/Blob themselves (naming/extension varies per flow) — this just owns
// the FormData shape and the endpoint.
export function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  return apiPost("/whatsapp/image_upload", fd).then(res => {
    const uploadedPath = typeof res.data === "string" ? res.data.trim() : "";
    if (!uploadedPath) {
      throw new Error(res.data?.message || "Image upload failed. Please try again.");
    }
    return uploadedPath;
  });
}
